import React from 'react';

import { Text as NativeBaseText } from 'native-base';

import type { TextColors, TextProps } from './Text.types';

const colors: TextColors = {
  default: 'gray.900',
  secondary: 'gray.600',
  disabled: 'gray.500',
  link: 'blue.500',
  error: 'red.500',
  warning: 'orange.700',
  success: 'green.500',
  white: 'white',
};

export const Text: React.FunctionComponent<TextProps> = ({
  color = 'default',
  ...props
}) => {
  return (
    <NativeBaseText
      color={color !== 'inherit' ? colors[color] : undefined}
      {...props}
    />
  );
};
